import * as React from 'react';
import Page from '../../../components/Page';
import LogsFilterContainer from '../containers/LogsFilterContainer';
import LogsTableContainer from '../containers/LogsTableContainer';
import { t } from '@moovly/i18n';

const LogsPage = () => (
  <Page header="logs" title={t('statistics.events.eventsTableTitle')}>
    <LogsFilterContainer />
    <LogsTableContainer />
  </Page>
);

export default LogsPage;
